<script>
	import { onMount } from "svelte";
	import { lang, settings } from "./store";

	import FamilySizeSelect from "./components/FamilySizeSelect.svelte";
	import ServiceProviderSelect from "./components/ServiceProviderSelect.svelte";
	import ServiceProviderHours from "./components/ServiceProviderHours.svelte";
	import IncomeInput from "./components/IncomeInput.svelte";
	import VoucherValue from "./components/VoucherValue.svelte";
	import ProviderCosts from "./components/ProviderCosts.svelte";
	import Municipality from "./components/Municipality.svelte";

	export let documentLanguage;
	$lang = documentLanguage;

	onMount(async () => {
		fetch("/wp-json/palvelusetelilaskuri/v1/settings")
			.then((response) => response.json())
			.then((data) => {
				settings.set(data);
			})
			.catch((error) => {
				console.log(error);
			});
	});
</script>

{#if !$settings}
	<section class="psl-container">Ladataan palvelusetelilaskuria...</section>
{:else}
	<section class="psl-container">
		<h2 class="screen-reader-text">Talouden perustiedot</h2>
		<div class="controls">
			<FamilySizeSelect />
			<IncomeInput />
		</div>
		<VoucherValue />
	</section>

	<section class="psl-container">
		<h2>Hankin palvelun yritykseltä</h2>
		<ServiceProviderSelect />
		<ServiceProviderHours />
		<ProviderCosts />
	</section>

	<div class="divider">
		<span>Tai</span>
	</div>

	<section class="psl-container">
		<h2>Käytän hyvinvointialueen järjestämiä palveluita</h2>
		<Municipality />
	</section>
{/if}

<style>
	.psl-container {
		display: flex;
		flex-direction: column;
		background-color: var(--color-gray);
		border-radius: var(--border-radius-large);
		padding: 2rem 1rem;
		margin-bottom: 1rem;
	}

	h2 {
		margin-top: 0;
		font-size: 1.5rem;
	}

	@media (min-width: 600px) {
		.psl-container {
			padding: 2rem;
		}
	}

	.divider {
		position: relative;
	}

	.divider span {
		text-transform: uppercase;
		background-color: var(--color-blue);
		color: var(--color-gray);
		width: 50px;
		height: 50px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 0 auto;
		border-radius: 1000px;
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
		top: calc(-25px - 0.5rem);
	}

	.controls {
		display: flex;
		flex-direction: column;
		gap: 1rem;
		margin-top: 0;
	}

	@media (min-width: 600px) {
		.controls {
			flex-direction: row;
		}
	}
</style>
